import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Country/GetAll', method: 'GET', body: null, token: token })
}
